export const educationTranslations = {
  // 教育和学生服务相关翻译
  "studentServices": {
    en: "Student Services",
    zh: "学生服务"
  },
  "studentServicesTitle": {
    en: "Student Services in Penang",
    zh: "槟城学生服务"
  },
  "studentServicesDesc": {
    en: "Comprehensive support for international students studying in Penang",
    zh: "为在槟城学习的国际学生提供全面支持"
  },
  "studentServicesIntro": {
    en: "Our dedicated student services team provides support for international students at every stage of their educational journey in Penang.",
    zh: "我们专业的学生服务团队为国际学生在槟城教育旅程的每个阶段提供支持。"
  },
  "comprehensiveStudentSupport": {
    en: "Comprehensive support for international students studying in Penang",
    zh: "为在槟城学习的国际学生提供全面支持"
  },
  "ourServicesForStudents": {
    en: "Our Services for Students",
    zh: "我们为学生提供的服务"
  },
  "studentServiceDescription": {
    en: "We offer a range of services to help international students navigate their educational journey in Penang, from application to graduation.",
    zh: "我们提供一系列服务，帮助国际学生在槟城的教育旅程中从申请到毕业的各个阶段。"
  },
  "universityApplication": {
    en: "University Application Assistance",
    zh: "大学申请协助"
  },
  "universityApplicationDesc": {
    en: "Guidance on choosing the right program and institution, and assistance with the application process.",
    zh: "选择合适的专业和院校指导，以及申请流程协助。"
  },
  "studentVisa": {
    en: "Student Visa Processing",
    zh: "学生签证办理"
  },
  "studentVisaDesc": {
    en: "Support with visa documentation, application submissions, and visa renewals during your study period.",
    zh: "签证文件支持、申请提交和学习期间的签证续签。"
  },
  "preDeparture": {
    en: "Pre-Departure Orientation",
    zh: "出发前准备"
  },
  "preDepartureDesc": {
    en: "Preparation information and checklists to ensure you're fully ready before arriving in Penang.",
    zh: "提供准备信息和清单，确保您在抵达槟城前做好充分准备。"
  },
  "accommodationSearch": {
    en: "Accommodation Search",
    zh: "住宿搜索"
  },
  "accommodationSearchDesc": {
    en: "Help finding suitable and affordable housing options near your campus, including hostels, apartments, and homestays.",
    zh: "帮助寻找校园附近适合且经济实惠的住宿选择，包括宿舍、公寓和寄宿家庭。"
  },
  "orientation": {
    en: "Arrival Orientation",
    zh: "抵达后指导"
  },
  "orientationDesc": {
    en: "Airport pickup, temporary accommodation arrangement, and orientation to help you settle in comfortably.",
    zh: "机场接机、临时住宿安排和指导，帮助您舒适安顿下来。"
  },
  "partTimeJob": {
    en: "Part-Time Job Assistance",
    zh: "兼职工作协助"
  },
  "partTimeJobDesc": {
    en: "Information on work opportunities and regulations for international students in Penang.",
    zh: "提供槟城国际学生的工作机会和相关规定信息。"
  },
  "academicGuidance": {
    en: "Academic Guidance",
    zh: "学术指导"
  },
  "academicGuidanceDesc": {
    en: "Study support, tutoring connections, and academic planning assistance.",
    zh: "学习支持、辅导联系和学术规划协助。"
  },
  "localBuddies": {
    en: "Local Buddies Program",
    zh: "本地伙伴计划"
  },
  "localBuddiesDesc": {
    en: "Connect with Malaysian students for social integration and cultural exchange.",
    zh: "与马来西亚学生联系，促进社交融合和文化交流。"
  },
  "universitiesInPenang": {
    en: "Universities and Colleges in Penang",
    zh: "槟城的大学和学院"
  },
  "universitiesDescription": {
    en: "Penang offers a variety of higher education institutions with excellent academic programs and modern facilities.",
    zh: "槟城提供多种高等教育机构，拥有优秀的学术课程和现代化设施。"
  },
  "usm": {
    en: "Universiti Sains Malaysia (USM)",
    zh: "马来西亚理科大学 (USM)"
  },
  "usmDesc": {
    en: "A premier public research university with a comprehensive range of undergraduate and postgraduate programs.",
    zh: "一所顶尖公立研究型大学，提供广泛的本科和研究生课程。"
  },
  "penangMedical": {
    en: "RCSI & UCD Malaysia Campus",
    zh: "爱尔兰皇家外科医学院与都柏林大学马来西亚分校"
  },
  "penangMedicalDesc": {
    en: "A private medical school offering Irish medical degrees in Malaysia.",
    zh: "一所在马来西亚提供爱尔兰医学学位的私立医学院。"
  },
  "wawasanUniversity": {
    en: "Wawasan Open University",
    zh: "宏愿开放大学"
  },
  "wawasanUniversityDesc": {
    en: "An open university specializing in flexible learning programs for working adults.",
    zh: "一所专门为在职成人提供灵活学习课程的开放大学。"
  },
  "distedCollege": {
    en: "DISTED College",
    zh: "迪斯迪学院"
  },
  "distedCollegeDesc": {
    en: "A private college offering pre-university, diploma, and degree programs in partnership with prestigious universities.",
    zh: "一所与知名大学合作提供预科、大专和学位课程的私立学院。"
  },
  "kduPenang": {
    en: "KDU Penang University College",
    zh: "KDU 槟城大学学院"
  },
  "kduPenangDesc": {
    en: "A premier private university college known for its industry-relevant programs and excellent facilities.",
    zh: "一所以其行业相关课程和卓越设施而闻名的顶尖私立大学学院。"
  },
  "internationalSchools": {
    en: "International Schools",
    zh: "国际学校"
  },
  "internationalSchoolsDesc": {
    en: "Penang offers several international schools following British, American, and international curricula for younger students.",
    zh: "槟城为年轻学生提供几所遵循英国、美国和国际课程的国际学校。"
  },
  "needMoreHelp": {
    en: "Need More Help With Your Studies?",
    zh: "需要更多学习帮助？"
  },
  "scheduleConsultation": {
    en: "Schedule a consultation with our education advisors to discuss your specific needs and get personalized assistance.",
    zh: "与我们的教育顾问预约咨询，讨论您的特定需求并获得个性化帮助。"
  },
  "bookConsultation": {
    en: "Book a Consultation",
    zh: "预约咨询"
  },
  "browseFAQs": {
    en: "Browse FAQs",
    zh: "浏览常见问题"
  },
  "educationResources": {
    en: "Education Resources",
    zh: "教育资源"
  },
  "scholarships": {
    en: "Scholarships",
    zh: "奖学金"
  },
  "scholarshipsDesc": {
    en: "Information on available scholarships for international students at Penang institutions.",
    zh: "关于槟城院校为国际学生提供的奖学金信息。"
  },
  "englishCourses": {
    en: "English Language Courses",
    zh: "英语语言课程"
  },
  "englishCoursesDesc": {
    en: "Pre-university English programs and language enhancement courses for international students.",
    zh: "为国际学生提供的大学预科英语课程和语言强化课程。"
  },
  "studyTips": {
    en: "Study in Malaysia Tips",
    zh: "马来西亚留学贴士"
  },
  "studyTipsDesc": {
    en: "Practical advice on adapting to the Malaysian education system and maximizing your learning experience.",
    zh: "关于适应马来西亚教育系统并最大化学习体验的实用建议。"
  }
};
